import type { GetHostsFilter } from '#api/hosts.ts';
import { ALL_ROLES_FLAG } from '../firewall-rule-form/FirewallRuleForm.queries.ts';
import type { FirewallRuleFormValues } from '../types.ts';

export function hasAllowedRole(allowedRoleID: FirewallRuleFormValues['allowedRoleID']): boolean {
  return Boolean(allowedRoleID && allowedRoleID !== ALL_ROLES_FLAG);
}

/** The API ANDs role and tags, matching the firewall rule's allowed hosts. */
export function allowedHostsFilter(
  { allowedRoleID, tags }: Pick<FirewallRuleFormValues, 'allowedRoleID' | 'tags'>,
  networkID: string
): GetHostsFilter {
  return {
    networkID,
    ...(hasAllowedRole(allowedRoleID) ? { roleID: allowedRoleID } : {}),
    ...(tags.length ? { tags } : {}),
  };
}
